import { EmotionPerfTest } from '@grafana/ui/internal';

export const BenchmarksPage = () => {
  return <EmotionPerfTest />;
};

export default BenchmarksPage;
